import { render, staticRenderFns } from "./Fiber.vue?vue&type=template&id=598c877e"
import script from "./Fiber.vue?vue&type=script&lang=js"
export * from "./Fiber.vue?vue&type=script&lang=js"
import style0 from "./Fiber.vue?vue&type=style&index=0&id=598c877e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports